import moment from "moment";

export namespace IApp {
  export const DATE_FORMAT_MOMENT = 'YYYY-MM-DD';
  export const DATE_FORMAT_ELEMENT_UI = 'yyyy-MM-dd';
  export const DATE_TIME_FORMAT_ELEMENT_UI = 'DD.MM.YYYY HH:mm:ss';

  export enum DateFormats {
    FromServer = 'YYYY-MM-DD[T00:00:00Z]',
    ToServer = 'YYYY-DD-MM HH:mm:ss',
    PrintedDate = 'DD.MM.YYYY',
    PrintedDateShortYear = 'DD.MM.YY',
    PrintedTime = 'HH:mm',
    PrintedDateShort = 'DD.MM',
    PrintedDateTime = 'DD.MM.YYYY HH:mm',
    PrintedSymbolDateTime = 'DD MMMM HH:mm',
    PrintedDateTimeShort = 'DD.MM HH:mm',
    PrintedDateTimeFull = 'DD.MM.YYYY HH:mm:ss',
    ElementDateFormat = 'dd.MM.yyyy',
    ElementDateTimeFormat = 'dd.MM.yyyy HH:mm',
    ElementDateTimeFullFormat = 'dd.MM.yyyy HH:mm:ss',
    TimeFull = 'HH:mm:ss',
  }

  export enum ROUTE_NAME {
    HOME = 'home',
    REDIRECT = 'redirect',
    REDIRECT_WITHOUT_CACHE = 'redirect-without-cache',
    PAGE_AUTHORIZATION = 'authorization',
    PAGE_PROFILE = 'profile',
    PAGE_CONFIRM_EMAIL = 'confirm-email',
    PAGE_404 = '404',
    PAGE_REGISTRATION = 'registration',
    PAGE_CAR_LIST = 'car-list',
    PAGE_BARRIERS = 'barriers',
    PAGE_PARKING_ACCESS = 'parking-access',
    PAGE_REPORT = 'report',
    PAGE_REPORT_MOVEMENTS = 'movements',
    PAGE_REPORT_BALANCE = 'balance',
    PAGE_REPORT_EVENTS = 'events',
    PAGE_REPORT_CARS = 'cars',
    PAGE_REPORT_PARKS = 'parks',
    PAGE_REPORT_CARS_BALANCE = 'cars-balance',
    PAGE_REPORT_AGENT = 'agent',
    PAGE_DASHBOARD = 'dashboard',
    PAGE_SUPPORT = 'support',
    PAGE_SCREEN_PAY = 'screen-pay',
    PAGE_PARKS_CONFIG = 'parks-config',
    PAGE_DEVICE_STATS = 'device-stats',
    PAGE_CORPS = 'corps',
    PAGE_FIND_DRIVER = 'find-driver',
    PAGE_PAYMENT_RESULT = 'payment-result',
  }

  export const RoutePath = {
    [ROUTE_NAME.HOME]: '/',
    [ROUTE_NAME.PAGE_AUTHORIZATION]: '/authorization',
    [ROUTE_NAME.PAGE_PROFILE]: '/profile',
    [ROUTE_NAME.PAGE_CONFIRM_EMAIL]: '/confirm-email',
    [ROUTE_NAME.PAGE_404]: '/404',
    [ROUTE_NAME.PAGE_REGISTRATION]: '/registration',
    [ROUTE_NAME.PAGE_CAR_LIST]: '/car-list',
    [ROUTE_NAME.PAGE_BARRIERS]: '/barriers',
    [ROUTE_NAME.PAGE_PARKING_ACCESS]: '/parking-access',
    [ROUTE_NAME.PAGE_REPORT]: '/report',
    [ROUTE_NAME.PAGE_REPORT_MOVEMENTS]: 'movements',
    [ROUTE_NAME.PAGE_REPORT_BALANCE]: 'balance',
    [ROUTE_NAME.PAGE_REPORT_EVENTS]: 'events',
    [ROUTE_NAME.PAGE_REPORT_CARS]: 'cars',
    [ROUTE_NAME.PAGE_REPORT_PARKS]: 'parks',
    [ROUTE_NAME.PAGE_REPORT_CARS_BALANCE]: 'cars-balance',
    [ROUTE_NAME.PAGE_REPORT_AGENT]: 'agent',
    [ROUTE_NAME.PAGE_DASHBOARD]: '/dashboard',
    [ROUTE_NAME.PAGE_SUPPORT]: '/support',
    [ROUTE_NAME.PAGE_SCREEN_PAY]: '/pay',
    [ROUTE_NAME.PAGE_PARKS_CONFIG]: '/parks-config',
    [ROUTE_NAME.PAGE_DEVICE_STATS]: '/device-stats',
    [ROUTE_NAME.PAGE_CORPS]: '/corps',
    [ROUTE_NAME.PAGE_FIND_DRIVER]: '/find-driver',
    [ROUTE_NAME.PAGE_PAYMENT_RESULT]: '/payment-result',
  };

  export const RedirectBlackList = [
    ROUTE_NAME.REDIRECT,
    ROUTE_NAME.REDIRECT_WITHOUT_CACHE,
    ROUTE_NAME.PAGE_AUTHORIZATION,
    ROUTE_NAME.PAGE_CONFIRM_EMAIL,
    ROUTE_NAME.PAGE_404,
  ];

  export enum GlobalCookie {
    AppThemeName = 'app-theme-name',
  }

  export enum LocalStorageKeys {
    DontDisplayInstallBanner = 'dont-display-install-banner',
    SelectParksGrouping = 'select-parking-grouping',
    LastAppUpdateDate = 'last-app-update-date',
    AppTableV2 = 'theme-settings:app-table-v2',
    PreviousRoute = 'app-previous-route',
    FeedbackAnonymousGUID = 'feedback-anonymousGUID',
  }

  export enum ThemeName {
    Light = 'light',
    Dark = 'dark',
  }

  export enum SortDirection {
    Up = 'asc',
    Down = 'desc',
    Default = 'default',
  }

  export enum SortingPropType {
    String = 'string',
    Number = 'number',
    Date = 'date',
    Boolean = 'boolean',
    Actions = 'actions',
    CustomComponent = 'custom-component',
  }

  export enum Status {
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
  }

  export const StatusLabel = {
    [Status.Success]: 'Успешно',
    [Status.Warning]: 'Внимание',
    [Status.Error]: 'Ошибка',
  }

  export const DatePickerOptions = {
    Simple: {
      firstDayOfWeek: 1,
    },
    WithDateShortcuts: {
      firstDayOfWeek: 1,
      shortcuts: [
        { text: 'Сегодня', onClick: (picker) => picker.$emit('pick', moment().toDate()) },
        { text: 'Вчера', onClick: (picker) => picker.$emit('pick', moment().add(-1, 'days').toDate()) },
        { text: 'Неделя назад', onClick: (picker) => picker.$emit('pick', moment().add(-1, 'weeks').toDate()) },
        { text: 'Месяц назад', onClick: (picker) => picker.$emit('pick', moment().add(-1, 'months').toDate()) },
        { text: 'Год назад', onClick: (picker) => picker.$emit('pick', moment().add(-1, 'years').toDate()) },
      ],
    },
  };
}
